import styled from '@emotion/styled'

const Wrapper = styled.div`
	${({ theme }) => `
		display: flex;
		border-radius: 12px;
		margin: 0;
		padding: 0;
		background-color: ${theme.palette.background.paper};
	`}
`

export { Wrapper }
